import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // 1. Redux hooks
import { Calendar } from 'antd';
import moment from 'moment';

import { TimeChooser, disabledDate, dateCellRender } from '.';
import { useMakeCalendar, useGetAvailability, useAvailabilityFilter } from './effects';
import { pushData } from '../utilities/pushData';

export default function DateTimePicker() {
  const dispatch = useDispatch();

  // 2. Selectors
  const inspectorAvailability = useSelector(state => state.inspectorAvailability);
  const date = useSelector(state => state.date);
  const calendar = useSelector(state => state.calendar);
  const restrict_schedule = useSelector(state => state.project?.restrict_schedule);
  const inspector = useSelector(state => state.inspector);
  const dateReset = useSelector(state => state.dateReset); // Assuming this is in state, based on your usage

  // 3. Effects Hooks (Converted below)
  useAvailabilityFilter();
  useGetAvailability();
  useMakeCalendar();

  // When the selected inspector changes, reset the calendar selection
  useEffect(() => {
    // Only dispatch if we have an inspector ID (prevents initial mount issues if needed)
    if (inspector?.id) {
       dispatch(pushData({ date: null, time: null, dateReset: true }));
    }
  }, [inspector?.id, dispatch]);

  function getDisabledDates() {
    if (restrict_schedule) return disabledDate(inspectorAvailability, date || moment());
    return (currentDate) => {
      // Do not disable past dates.
      return false;
    };
  }

  const restricted = restrict_schedule && inspector && inspector.id && !inspectorAvailability;

  console.log('DateTimePicker renders');

  return (
    <div>
      {inspector && inspector.id && (
        <div className="calendar-wrapper">
          <Calendar
            value={date ? date : moment()}
            disabledDate={getDisabledDates()}
            onChange={(e) => dispatch(pushData({ time: null, date: e, dateReset: false }))}
            dateCellRender={dateCellRender(calendar)}
            className={dateReset ? 'reset-calendar' : ''}
            fullscreen={false}
          />
        </div>
      )}
      {restricted && <div className="padding-1">Selected Field User has no availability this month</div>}
      
      {/* 4. Pass props explicitly or let TimeChooser select from Redux. 
          Since TimeChooser is refactored below to use Redux, we just render it. */}
      {date && <TimeChooser inspector={inspector} />}
    </div>
  );
}